import { Component, effect, input, OnInit, output, signal, inject, Signal, computed } from '@angular/core';
import { CurrencyPipe, NgClass } from '@angular/common';
import { DashboardApiService } from '../../../../../_services/dashboard-api-service/dashboard-api.service';
import { AccountBalanceWidget } from '../../../../../_interfaces/dashboard.interface';
import { DashboardWidgetBaseComponent } from '../dashboard-widget-base.component';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';
import { CircleGraphComponent } from '../../../../../shared/components/circle-graph/circle-graph.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-account-balance-widget',
  imports: [CurrencyPipe, NgClass, EmptyIndicatorPipe, CircleGraphComponent, RouterLink],
  templateUrl: './account-balance-widget.component.html',
  styleUrl: `./account-balance-widget.component.scss`,
})
export class AccountBalanceWidgetComponent extends DashboardWidgetBaseComponent implements OnInit {
  readonly dashboardApiService = inject(DashboardApiService);

  isEmployeeCardBalance = input<boolean>(true);
  isFundAccount = input<boolean>(false);
  displayData = input<AccountBalanceWidget | undefined>(undefined);
  showFundAccountAlert = output<boolean>();
  accountBalance = signal<AccountBalanceWidget | undefined>(undefined);
  showError = signal<boolean>(false);

  protected allocationPercentagePhysical: Signal<number> = computed(() => {
    if (this.accountBalance()?.balance_physical_cards) {
      return (
        (Number(this.accountBalance()?.balance_physical_cards) / Number(this.accountBalance()?.total_physical)) * 100
      );
    } else {
      return 0;
    }
  });

  protected allocationPercentageVirtual: Signal<number> = computed(() => {
    if (this.accountBalance()?.balance_virtual_cards) {
      return (
        (Number(this.accountBalance()?.balance_virtual_cards) / Number(this.accountBalance()?.total_virtual)) * 100
      );
    } else {
      return 0;
    }
  });

  constructor() {
    super();
    effect(() => {
      const data = this.displayData();
      if (this.isFundAccount() && data) {
        this.accountBalance.set(data);
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {
    // Only fetch if NOT in the fund account flow
    if (!this.isFundAccount()) {
      this.fetchAccountBalance();
    }
  }

  fetchAccountBalance() {
    this.subscriptions.add(
      this.dashboardApiService.getAccountBalance().subscribe({
        next: (res) => {
          this.isLoading = false;
          this.accountBalance.set(res);
          if (this.accountBalance()?.balance_physical === '0.00' || this.accountBalance()?.balance_virtual === '0.00') {
            this.showFundAccountAlert.emit(true);
          }
        },
        error: () => {
          this.isLoading = false;
          this.showError.set(true);
        },
      }),
    );
  }
}
